import { Button, Divider, Space, Tooltip } from "antd";

import {
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
} from "react-share";

import { FBIcon, InstagramIcon, TwitterIcon, EnvelopIcon, LinkIcon } from "@components/icons/Icons";
import CopyToClipboardButton from "@components/copy-to-clipboard-button";
import { EmailDetails } from "@customTypes/index";

export interface SocialHandle {
  isEnabled: boolean;
  url?: string,
  handle?: string,
}

export interface TwiiterSocialHandle extends SocialHandle {
  text?: string,
  via?: string,
}

export interface ExtendedEmailShare extends EmailDetails {
  isEnabled: boolean;
}

interface ShareSocialMediaButtonsProps {
  style?: React.CSSProperties;
  className?: string;
  email?: ExtendedEmailShare,
  facebook?: SocialHandle;
  twitter?: TwiiterSocialHandle
  instagram?: SocialHandle
  article?: {
    isEnabled: boolean;
    url?: string,
  }
}

const defaultProps: ShareSocialMediaButtonsProps = {
  email: { isEnabled: false },
  facebook: { isEnabled: false },
  twitter: { isEnabled: false },
  instagram: { isEnabled: false },
  article: { isEnabled: true },
};

const ShareSocialMediaButtons = ({
  style,
  className,
  email,
  facebook,
  twitter,
  instagram,
  article,
}: ShareSocialMediaButtonsProps) => {
  const css: string[] = ["share-social-media"];

  if (className) {
    css.push(className);
  }

  return (
    <Space className={css.join(' ')} align="center" style={style}>
      {email?.isEnabled &&
        <EmailShareButton
          subject={email.subject}
          url={``}
          body={email.body}
          children={
            <Tooltip title="Mail To">
              <EnvelopIcon />
            </Tooltip>
          }
        />
      }
      {article?.isEnabled &&
        article?.url &&
        <CopyToClipboardButton
          icon={<LinkIcon />}
          type={`link`}
          textToCopy={article.url}
        />
      }
      <Divider type="vertical" />
      {facebook?.isEnabled &&
        facebook?.url &&
        <FacebookShareButton
          url={facebook.url}
          children={
            <Tooltip title="Share on Facebook">
              <FBIcon />
            </Tooltip>
          }
        />
      }
      {instagram?.isEnabled &&
        instagram?.url &&
        <Button
          type="link"
          href={instagram.handle}
          target="_blank"
          children={
            <Tooltip title="Visit our Instagram page.">
              <InstagramIcon />
            </Tooltip>
          }
        />
      }
      {twitter?.isEnabled &&
        twitter?.url &&
        <TwitterShareButton
          url={twitter.url}
          title={twitter.text}
          via={twitter.handle}
          children={
            <Tooltip title="Share on Twitter">
              <TwitterIcon />
            </Tooltip>
          }
        />
      }
    </Space >
  );
};

ShareSocialMediaButtons.defaultProps = defaultProps;

export default ShareSocialMediaButtons;

